import React from "react";
import { useAuth } from "@syos-music/auth";

import { Box, Container, Grid, Typography, Link } from "@mui/material";

const LINKS_URL =
  process.env.REACT_APP_API_BASE_URL + "/useful-links/list.json";

async function getLinks(auth) {
  const accessToken = await auth.getAccessToken();
  if (!accessToken) return;

  return fetch(LINKS_URL, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  }).then((res) => res.json());
}

export default function HomePage() {
  const auth = useAuth();
  const [links, setLinks] = React.useState();

  React.useEffect(() => {
    getLinks(auth).then(setLinks);
  }, [auth]);

  return (
    <Container fixed sx={{ paddingTop: { xs: 2, sm: 3 } }}>
      <Grid container alignItems="center" justifyContent="center">
        {links && links.tech && (
          <Grid item xs={12} sm={4}>
            {links.tech.map((link, idx) => (
              <Typography key={idx} paragraph>
                <Link href={link.url} target="_blank" rel="noopener noreferrer">
                  {link.title}
                </Link>
              </Typography>
            ))}
          </Grid>
        )}

        <Grid item xs={12} sm={4}>
          <Box
            component="img"
            src="/lapidou.svg"
            alt=""
            sx={{
              width: "80%",
              margin: (t) => t.spacing(4, "auto"),
              display: "block",
            }}
          />
        </Grid>

        {links && links.nonTech && (
          <Grid item xs={12} sm={4}>
            {links.nonTech.map((link, idx) => (
              <Typography key={idx} paragraph align="right">
                <Link href={link.url} target="_blank" rel="noopener noreferrer">
                  {link.title}
                </Link>
              </Typography>
            ))}
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
